import { render, staticRenderFns } from "./zhiliuping.vue?vue&type=template&id=1d1523fc&scoped=true&"
import script from "./zhiliuping.vue?vue&type=script&lang=js&"
export * from "./zhiliuping.vue?vue&type=script&lang=js&"
import style0 from "./zhiliuping.vue?vue&type=style&index=0&id=1d1523fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1523fc",
  null
  
)

export default component.exports